import React from "react";

export const ScreenBackground = ({
  background,
  screenName,
  gridArea,
}: {
  background?: string;
  screenName?: string;
  gridArea: string;
}) => {
  return (
    <div
      id={`ScreenBackground-${screenName ? screenName : ""}`}
      style={{
        background,
        gridArea,
        borderRadius: "0.75rem",
        overflow: "hidden",
      }}
    />
  );
};
